import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
export const addPlacesApis = async (data, onSuccess) => {
  try {
    let response = await _axios.post(END_POINTS.ADD_PLACE, data);
    if (onSuccess) onSuccess(response?.data);
    console.log("response in  added places", response);
    return response?.data?.data;
  } catch (e) {
    console.log("error in saved places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getPlacesApis = async (status) => {
  try {
    let response = await _axios.get(
      `${END_POINTS.ADD_PLACE}my?status=${status}`
    );
    console.log("response in get places", response);
    return response?.data?.data;
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getPlaceDetailsApis = async (ID) => {
  try {
    let response = await _axios.get(`${END_POINTS.GET_PLACE_DETAILS}${ID}`);
    console.log(response);
    return {
      success: true,
      data: response?.data?.data?.place,
    };
  } catch (e) {
    console.log("errror in place details", e);
    return {
      success: false,
      error: e,
    };
  }
};

export const editPlaceDetailsApis = async (id, data) => {
  try {
    let response = await _axios.put(
      `${END_POINTS.EDIT_PLACE_DETAILS}${id}`,
      data
    );
    console.log({ response });
    return {
      success: true,
      message: response,
    };
  } catch (e) {
    console.log("error===>", e);

    return {
      success: false,
      error: e,
    };
  }
};

export const StatusTabPressPlaceDetailsApis = async (status) => {
  try {
    let response = await _axios.get(
      `${END_POINTS.GET_PLACE_DETAILS_BY_STATUS}${status}`
    );
    console.log(response);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("errror=====---===>", e);
    return {
      success: false,
      error: e,
    };
  }
};

/** Places stats */

export const PlacesStatsApis = (id, type) => {
  return _axios
    .get(`${END_POINTS.PLACES_STAS}${id}/stats?type=${type}`)
    .then((response) => ({
      success: true,
      data: response.data,
    }))
    .catch((e) => ({
      success: false,
      error: e,
    }));
};
